import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { Avatar } from '@/components/ui/Image/Avatar';
import { ContentWithAvatar } from '@/components/ui/Image/ContentWithAvatar';
import { Text } from '@/components/ui/Typography/Body/Text';
import { LinkHead } from '@/components/ui/Typography/Heading/LinkHead';
import { PROFESSIONAL_TYPE_NORMAL } from '@/define/consts/professional/professional_user';
import { professionalsOnePath, freeProfessionalOnePath, } from '@/utils/router/links';
/**
 * ユーザー情報表示コンポーネント
 * src/container/Client/Rfp/One/Parts/User/UserBox.js から移行
 */
export const UserBox = (props) => {
    const { avatarSize = 'md', className = '', extraTexts = [], firstName, id, imageSrc, isNestedLink = false, isShowDetailPage = true, lastName, professionalType, } = props;
    const name = `${lastName} ${firstName}`;
    const userDetailPath = professionalType === PROFESSIONAL_TYPE_NORMAL
        ? professionalsOnePath(id.toString())
        : freeProfessionalOnePath(id.toString());
    const userDetailLinkProps = {
        isNestedLink,
        noLinkElement: isShowDetailPage ? undefined : 'span',
        target: '_blank',
        to: userDetailPath,
    };
    return (_jsx(ContentWithAvatar, Object.assign({ avatarComponent: 
        /* 画像 */
        _jsx(DynamicLink, Object.assign({}, userDetailLinkProps, { className: clsx(!isShowDetailPage ? 'pointer-events-none' : 'hover:cursor-pointer') }, { children: _jsx(Avatar, { alt: `${name}画像`, size: avatarSize, src: imageSrc }) })), className: className }, { children: _jsxs("div", Object.assign({ className: clsx('flex flex-col gap-y-4') }, { children: [_jsx(DynamicLink, Object.assign({}, userDetailLinkProps, { className: clsx('group', !isShowDetailPage && 'pointer-events-none') }, { children: _jsx(LinkHead, Object.assign({ baseTextColor: 'base', className: 'break-all whitespace-normal', isGroup: true, size: 'xxs' }, { children: name })) })), extraTexts.map(({ link: extraLink, text: extraText }, i) => (_jsx(DynamicLink, Object.assign({ isNestedLink: isNestedLink, noLinkElement: extraLink ? undefined : 'span', target: '_blank', to: extraLink || '' }, { children: _jsx(Text, Object.assign({ className: clsx('break-all whitespace-normal', extraLink && 'hover:underline'), color: 'textGray', size: 'xs' }, { children: extraText })) }), `${extraText}${i + 1}`)))] })) })));
};
